import { iRootDispatch } from '../store';

export type SettingsState = {
    expandMenu: boolean;
};

export const Settings = {
    state: {
        expandMenu: false,
    } as SettingsState,
    reducers: {
        expand: (state: SettingsState, expand: boolean): SettingsState => {
            return { expandMenu: expand };
        },
    },
    effects: (dispatch: iRootDispatch) => ({
        async expandMenu(payload: { expand: boolean }) {
            dispatch.settings.expand(payload);
        },
    }),
    selectors: () => ({}),
};

export default Settings;
